import React, { useState, useRef, useEffect } from 'react';
import {
  GoogleMap,
  Marker,
  LoadScript,
} from '@react-google-maps/api';

const mapStyle = {
  height: '500px',
  width: '100%',
};

const outerContainerStyle = {
  width: '1300px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginTop: '20px',
};

const leftPaneStyle = {
  width: '48%',
  height: '500px',
};

const rightPaneStyle = {
  width: '48%',
  height: '500px',
  border: '1px solid #ccc',
};

const markerColors = {
  input: '#ff0000',
  google: '#ff9300',
  tomtom: '#fff900',
  here: '#73ff00',
  osm: '#00f3ff',
  azure: '#000fff',
  uscensus: '#fc00ff',
};

const GoogleMapWithStreetView = ({ coordinates = [], baseAddressParts , county}) => {
  const [selected, setSelected] = useState(coordinates[0] || null);
  const mapRef = useRef(null);
  const streetViewRef = useRef(null);
  const streetViewPanoramaRef = useRef(null);
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const fullAddress = `${baseAddressParts.streetNumber} ${baseAddressParts.streetName}, ${baseAddressParts.city}, ${baseAddressParts.state} ${baseAddressParts.zipcode}`;
  const parcelViewer = `${county} County, ${baseAddressParts.state} parcel map`

  useEffect(() => {
    if (selected && window.google && streetViewRef.current) {
      if (!streetViewPanoramaRef.current) {
        // Initialize the Street View Panorama
        streetViewPanoramaRef.current = new window.google.maps.StreetViewPanorama(
          streetViewRef.current,
          {position: selected,pov: { heading: 210, pitch: 10 },zoom: 1}
        );
      } else {
        // Update existing Panorama position
        streetViewPanoramaRef.current.setPosition(selected);
      }
    }
  }, [selected]);

  useEffect(() => {
    if (coordinates.length > 0) {
      setSelected(coordinates[0]);
    }
  }, [coordinates]);

  return (
    <LoadScript googleMapsApiKey={apiKey}>
      <div className='card map-card'>
        <h2 className="heading2">Select a coordinate:</h2>
        <div className='coordinate-buttons'>
        {coordinates.map((coord, idx) => (
          <button
            key={idx}
            onClick={() => setSelected(coord)}
            style={{margin: '4px', padding: '6px 10px',border: '1px solid #ccc', backgroundColor: markerColors[coord.source?.toLowerCase()] || 'gray', color: 'black'}}
          >
            {coord.source || `Source ${idx + 1}`}
          </button>
        ))}
        </div>

        <div className="map-conatiner" style={outerContainerStyle}>
          {/* Google Map */}
          <div className="map-frame" style={leftPaneStyle}>
            <GoogleMap mapContainerStyle={mapStyle} center={selected || { lat: 38.9426, lng: -77.3245 }} zoom={17} mapTypeId="hybrid" onLoad={(map) => (mapRef.current = map)}>
              {coordinates.map((coord, idx) => (
                <Marker
                  key={idx}
                  position={{ lat: coord.lat, lng: coord.lng }}
                  icon={
                    window.google?.maps?.SymbolPath
                      ? {path: window.google.maps.SymbolPath.CIRCLE, scale: 7, fillColor: markerColors[coord.source?.toLowerCase()] || 'gray', fillOpacity: 1, strokeWeight: 1}
                      : undefined
                  }
                  onClick={() => setSelected(coord)}
                />
              ))}
            </GoogleMap>
          </div>
          {/* Street View */}
          <div className="street-view-frame" style={rightPaneStyle} ref={streetViewRef}></div>
        </div>
      </div>
      {selected && (
        <div className="card">
          <h2 className="heading2">Additional Resources</h2>
          <div className='additionalResources'>
            <a className='resourceButton' target="_blank" rel="noopener noreferrer"
              href={`https://broadbandmap.fcc.gov/area-summary/fixed?version=jun2024&zoom=16.67&vlon=${selected.lng}&vlat=${selected.lat}&br=r&speed=100_20&tech=1_2_3_4_5_6_7_8`}
            >FCC Broadband Map</a>

            <a className='resourceButton' target="_blank" rel="noopener noreferrer"
              href={`https://www.google.com/search?q=${fullAddress}`}
            >Search Google for Address</a>

            <a className='resourceButton' target="_blank" rel="noopener noreferrer"
              href={`https://www.google.com/search?q=${parcelViewer}`}
            >Search Google for County Parcel Map</a>

          </div>
        </div>
      )}
    </LoadScript>
    
  );
};

export default GoogleMapWithStreetView;